import styled from 'styled-components';

export const StyledModalContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 24px;
    align-items: center;
    width: 353px;
    gap: 24px;
    text-align: center;
`;

export const StyledIconContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 24px;
    width: 72px;
    height: 72px;
    background-color: ${({ theme }) => theme.colors.darkTheme};
    border-radius: 50%;
`;

export const StyledDetailsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    text-align: center;
`;

export const StyledButtonContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
`;

export const StyledWarningModalContent = styled.div`
    display: flex;
    align-items: start;
    gap: 8px;
    padding: 8px;
    border-radius: 8px;
    background-color: ${({ theme }) => theme.colors.surface0};
`;
